<div class="warning-confirmation-dialog">
	<div class="close-button">
		<button mat-icon-button mat-dialog-close>
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div class="content">
		<mat-icon class="warning-icon">error_outline</mat-icon>
		<div class="title">{{ data?.title }}</div>
		<div class="body">{{ data?.content }}</div>
		<div class="buttons">
			<button
				mat-stroked-button
				color="primary"
				class="btn cancel"
				(click)="onCancelClick()"
			>
				{{ data?.cancelBtnText ?? "Cancel" }}
			</button>
			<button
				mat-flat-button
				color="primary"
				class="btn proceed"
				(click)="onProceedClick()"
			>
				{{ data?.okBtnText ?? "Proceed" }}
			</button>
		</div>
	</div>
</div>
